import React from 'react';
import MarketingLayout from './MarketingLayout';
import { useEffect, useState } from 'react';
import { getPublicChannelItems } from '../../services/content';
import { ContentItem } from '../../types/content';
import { sanitizeAndNormalizeRichText } from '../../utils/richText';
import { useDocumentMeta } from '../../hooks/useDocumentMeta';

const FAQPage: React.FC = () => {
  useDocumentMeta({
    title: '常见问题',
    description: '安飞供应链常见问题解答，涵盖海外仓入库、仓储、转运、出库和收费等客户最常咨询的问题。',
  });

  const [qaRows, setQaRows] = useState<ContentItem[]>([]);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getPublicChannelItems('faq');
        setQaRows(data.results || []);
      } catch {
        setQaRows([]);
      }
    };
    load();
  }, []);

  return (
    <MarketingLayout>
      <section className="mx-auto max-w-6xl px-6 py-14">
        <h1 className="text-3xl font-bold text-gray-900">常见问题</h1>
        <p className="mt-3 max-w-3xl text-sm leading-7 text-gray-600">
          以下为目前客户最常咨询的问题。若你的业务场景更复杂，欢迎直接联系团队沟通。
        </p>
      </section>

      <section className="mx-auto max-w-6xl space-y-3 px-6 pb-20">
        {qaRows.length ? (
          qaRows.map((x) => (
            <div key={x.id} className="rounded-xl border border-[#d9eaff] bg-white p-5 shadow-sm">
              <h3 className="text-base font-semibold text-[#2f82e8]">{x.title}</h3>
              <div
                className="content-rich-text mt-2 text-sm leading-7 text-gray-600"
                dangerouslySetInnerHTML={{ __html: sanitizeAndNormalizeRichText(x.body || x.summary || '') }}
              />
            </div>
          ))
        ) : (
          <div className="rounded-xl border border-[#d9eaff] bg-white p-5 text-sm text-gray-500 shadow-sm">
            暂无常见问题内容
          </div>
        )}
      </section>
    </MarketingLayout>
  );
};

export default FAQPage;
